<template>
  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{
          mess.dialog_marketing_materials_title
        }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row
            v-for="(item, i) in marketingMaterialsData"
            :key="i"
            class="align-center"
          >
            <v-col cols="auto">
              <svg width="40" height="40">
                <use xlink:href="/assets/svg/sprite.svg#pdf-icon"></use>
              </svg>
            </v-col>
            <v-col>
              <a :href="item.href" download>{{ item.title }}</a>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-btn absolute top right text icon @click="dialog = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "MarketingMaterialsDialog",
  props: {
    isVisible: {
      type: Boolean,
      default: false
    },
    marketingMaterialsData: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    dialog: false
  }),
  watch: {
    isVisible(val) {
      this.dialog = val;
    },
    dialog(val) {
      this.$emit("update:is-visible", val);
    }
  }
};
</script>

<style scoped></style>
